import { inject, Injectable } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { LanguageService } from '../../../../core/services/language.service';
import { DialogService } from '../../../../osp-ui/services/dialog.service';
import { ViewProject } from '../../../disposition/projects/contract/view-project.contract';
import { ProjectAddEditDialogComponent } from '../components/project-add-edit-dialog.component';

@Injectable({ providedIn: 'root' })
export class ProjectAddEditDialogService {
  private readonly dialogService = inject(DialogService);
  private readonly languageService = inject(LanguageService);
  private readonly DIALOG_WIDTH = '1200px';
  private readonly DIALOG_HEIGHT = '830px';

  open(): DynamicDialogRef<ProjectAddEditDialogComponent> {
    return this.dialogService.open(ProjectAddEditDialogComponent, {
      header: this.languageService.getInstant('modules.locations.project.create.header'),
      width: this.DIALOG_WIDTH,
      height: this.DIALOG_HEIGHT,
    });
  }

  openEdit(project: ViewProject): DynamicDialogRef<ProjectAddEditDialogComponent> {
    return this.dialogService.open(ProjectAddEditDialogComponent, {
      header: this.languageService.getInstant('modules.locations.project.edit.header'),
      width: this.DIALOG_WIDTH,
      height: this.DIALOG_HEIGHT,
      data: {
        project,
      },
    });
  }
}
